import * as React from 'react';

import { useAtomValue } from 'jotai';

import {
  $editorNodes,
  $isCreateMode,
} from '../../_state/automationEditor.state';

import { FlowEditor } from './FlowEditor';
import { isTriggerNodeType } from './nodes/types';
import { TriggerSelectionPanel } from './TriggerSelectionPanel';

/**
 * Flow tab content for the automation editor
 * Shows the visual flow editor and trigger selection panel (when in create mode)
 */
export const FlowTabContent = () => {
  const isCreateMode = useAtomValue($isCreateMode);
  const nodes = useAtomValue($editorNodes);

  const hasTriggerNode = React.useMemo(
    () => nodes.some((node) => node.type && isTriggerNodeType(node.type)),
    [nodes],
  );

  return (
    <div className="@FlowTabContent relative h-full overflow-hidden bg-white">
      <FlowEditor />
      {isCreateMode && !hasTriggerNode && <TriggerSelectionPanel />}
    </div>
  );
};
